import React from 'react';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './LegalPages.module.css';

const PrivacyPolicyPage = () => {
  return (
    <Page title="Politique de Confidentialité | Neokasa" description="Comment nous collectons, utilisons et protégeons vos informations personnelles." scrollingDisabled={false}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <div className={css.container}>
            <div className={css.header}>
              <h1 className={css.title}>Politique de Confidentialité</h1>
              <p className={css.subtitle}>Comment nous collectons, utilisons et protégeons vos informations personnelles</p>
            </div>

            <div className={css.policyContent}>
              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>1. Objet de la Politique</h2>
                <p className={css.paragraph}>
                  La présente Politique explique comment nous collectons, utilisons et protégeons les données personnelles des utilisateurs (« vous ») de notre marketplace de produits domotiques (la « Marketplace »).
                </p>
                <p className={css.paragraph}>
                  Elle est conforme au <strong>Règlement Général sur la Protection des Données (RGPD)</strong> et à la <strong>loi Informatique et Libertés</strong>.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>2. Responsable du Traitement</h2>
                <p className={css.paragraph}>
                  Le responsable du traitement des données personnelles est :
                </p>
                <p className={css.paragraph}>
                  <strong>NEOKASA</strong><br />
                  SARL immatriculee au RCS de Draguignan sous le numero 895 231 140<br />
                  Raison sociale : Neokasa<br />
                  Forme juridique : SARL<br />
                  RCS : Draguignan 895 231 140<br />
                  Siege social : 1701A route d'esparron 83560 Ginasservis<br />
                  Capital social : 100 EUR<br />
                  TVA intracommunautaire : non communique<br />
                  Email : contact@neokasa.fr
                </p>
                <p className={css.paragraph}>
                  <strong>DPO / referent RGPD :</strong> Aucun DPO designe a ce jour.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>3. Données Collectées</h2>
                <p className={css.paragraph}>
                  Nous collectons uniquement les données nécessaires au fonctionnement de la Marketplace :
                </p>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>3.1 Données fournies directement par vous</h3>
                <ul className={css.list}>
                  <li className={css.listItem}>Nom, prénom</li>
                  <li className={css.listItem}>Adresse email</li>
                  <li className={css.listItem}>Adresse postale pour les livraisons</li>
                  <li className={css.listItem}>Informations de paiement (gérées par un prestataire externe sécurisé, jamais stockées par la Marketplace)</li>
                  <li className={css.listItem}>Historique de commandes</li>
                  <li className={css.listItem}>Messages échangés via la plateforme</li>
                </ul>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>3.2 Données collectées automatiquement</h3>
                <ul className={css.list}>
                  <li className={css.listItem}>Données de navigation et de performance via <strong>Google Analytics</strong></li>
                  <li className={css.listItem}>Adresse IP</li>
                  <li className={css.listItem}>Informations techniques (type d'appareil, navigateur, etc.)</li>
                </ul>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>3.3 Données liées au compte vendeur (si applicable)</h3>
                <ul className={css.list}>
                  <li className={css.listItem}>Informations professionnelles</li>
                  <li className={css.listItem}>Informations légales requises pour la vente en ligne</li>
                </ul>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>4. Finalités du Traitement</h2>
                <p className={css.paragraph}>
                  Vos données sont utilisées pour :
                </p>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>4.1 Fournir nos services</h3>
                <ul className={css.list}>
                  <li className={css.listItem}>Gestion des comptes utilisateurs</li>
                  <li className={css.listItem}>Passation et suivi des commandes</li>
                  <li className={css.listItem}>Mise en relation Acheteurs ↔ Vendeurs</li>
                  <li className={css.listItem}>Support client et médiation des litiges</li>
                  <li className={css.listItem}>Hébergement et fonctionnement technique (via <strong>Heroku</strong>)</li>
                </ul>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>4.2 Améliorer la plateforme</h3>
                <ul className={css.list}>
                  <li className={css.listItem}>Analyse de trafic et de performance (via <strong>Google Analytics</strong>, basé sur votre consentement)</li>
                  <li className={css.listItem}>Sécurité et prévention des fraudes (logging, contrôle d'accès)</li>
                </ul>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>4.3 Obligations légales</h3>
                <ul className={css.list}>
                  <li className={css.listItem}>Comptabilité</li>
                  <li className={css.listItem}>Lutte contre la fraude</li>
                  <li className={css.listItem}>Respect des obligations du Code de la Consommation</li>
                </ul>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>5. Base Légale du Traitement</h2>
                <p className={css.paragraph}>
                  Conformément au RGPD (articles 6 et suivants), les traitements reposent sur :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}><strong>Exécution du contrat</strong> (compte, commandes, relation Acheteur/Vendeur)</li>
                  <li className={css.listItem}><strong>Obligation légale</strong> (facturation, sécurité, vérifications anti-fraude)</li>
                  <li className={css.listItem}><strong>Intérêt légitime</strong> (amélioration du service, sécurité)</li>
                  <li className={css.listItem}><strong>Consentement</strong> (cookies non essentiels, Google Analytics)</li>
                </ul>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>6. Destinataires des Données</h2>
                <p className={css.paragraph}>
                  Vos données peuvent être transmises uniquement aux destinataires nécessaires :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}><strong>Vendeurs</strong> : uniquement pour les commandes que vous passez</li>
                  <li className={css.listItem}><strong>Prestataires techniques</strong> :
                    <ul className={css.list} style={{ marginTop: '8px', paddingLeft: '20px' }}>
                      <li className={css.listItem}><strong>Heroku</strong> : hébergement des données et opérations serveur</li>
                      <li className={css.listItem}><strong>Shartribe (Sharetribe)</strong> : logiciel backend, gestion marketplace</li>
                      <li className={css.listItem}><strong>Stripe</strong> : traitement securise des paiements</li>
                      <li className={css.listItem}><strong>Google Analytics 4 (GA4)</strong> : analyse de performance et trafic (donnees pseudonymisees)</li>
                      <li className={css.listItem}><strong>Resend</strong> : envoi d'emails transactionnels</li>
                      <li className={css.listItem}><strong>Tidio</strong> : support client et messagerie</li>
                    </ul>
                  </li>
                </ul>
                <p className={css.paragraph}>
                  Nous ne revendons jamais vos données.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>7. Stockage et Transfert des Données</h2>
                <p className={css.paragraph}>
                  Les données peuvent être hébergées ou traitées en dehors de l'Union européenne par certains prestataires (ex. Heroku, Google), mais toujours sous couvert de :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}>Clauses Contractuelles Types (CCT)</li>
                  <li className={css.listItem}>Mesures supplémentaires de sécurité</li>
                  <li className={css.listItem}>Engagement de conformité au RGPD</li>
                </ul>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>8. Durée de Conservation</h2>
                <p className={css.paragraph}>
                  Nous conservons vos données uniquement le temps nécessaire :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}>Données de compte utilisateur : 12 mois maximum</li>
                  <li className={css.listItem}>Données de commande et de relation client : 12 mois maximum</li>
                  <li className={css.listItem}>Données de support client : 12 mois maximum</li>
                  <li className={css.listItem}>Cookies analytiques : 12 mois maximum</li>
                  <li className={css.listItem}>Logs techniques : 12 mois maximum</li>
                </ul>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>9. Vos Droits (RGPD)</h2>
                <p className={css.paragraph}>
                  Vous disposez des droits suivants :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}><strong>Droit d'accès</strong></li>
                  <li className={css.listItem}><strong>Droit de rectification</strong></li>
                  <li className={css.listItem}><strong>Droit à l'effacement (« droit à l'oubli »)</strong></li>
                  <li className={css.listItem}><strong>Droit à la limitation du traitement</strong></li>
                  <li className={css.listItem}><strong>Droit d'opposition</strong></li>
                  <li className={css.listItem}><strong>Droit à la portabilité</strong></li>
                  <li className={css.listItem}><strong>Droit de retirer votre consentement</strong> (ex : Google Analytics)</li>
                </ul>
                <p className={css.paragraph}>
                  Pour exercer vos droits :<br />
                  ➡️ Contactez-nous à <a href="mailto:contact@neokasa.fr" className={css.legalLink}>contact@neokasa.fr</a>.<br />
                  Nous vous répondrons sous 30 jours maximum.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>10. Cookies</h2>
                <p className={css.paragraph}>
                  Nous utilisons :
                </p>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>Cookies strictement nécessaires</h3>
                <p className={css.paragraph}>
                  Indispensables au fonctionnement de la Marketplace (connexion, panier, sécurité).<br />
                  Aucun consentement requis.
                </p>
                <h3 className={css.sectionTitle} style={{ fontSize: '18px', marginTop: '16px', marginBottom: '12px' }}>Cookies analytiques (Google Analytics)</h3>
                <p className={css.paragraph}>
                  Utilisés uniquement si vous acceptez les cookies non essentiels.<br />
                  Ils permettent de mesurer l'audience et améliorer l'expérience utilisateur.
                </p>
                <p className={css.paragraph}>
                  Un bandeau cookies vous permet de gérer vos préférences.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>11. Sécurité</h2>
                <p className={css.paragraph}>
                  Nous appliquons des mesures de sécurité techniques et organisationnelles :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}>Chiffrement HTTPS</li>
                  <li className={css.listItem}>Accès restreint aux données</li>
                  <li className={css.listItem}>Sauvegardes sécurisées</li>
                  <li className={css.listItem}>Procédures internes en cas de violation de données</li>
                </ul>
                <p className={css.paragraph}>
                  En cas de faille de sécurité, nous notifions la CNIL et, si nécessaire, les utilisateurs concernés.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>12. Modifications de la Politique</h2>
                <p className={css.paragraph}>
                  Cette Politique peut être modifiée à tout moment.
                </p>
                <p className={css.paragraph}>
                  En cas de changement important, vous serez informé par email ou notification sur la Marketplace.
                </p>
                <p className={css.paragraph}>
                  <strong>Derniere mise a jour :</strong> 26 mars 2026.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>13. Contact</h2>
                <p className={css.paragraph}>
                  Pour toute question sur vos données personnelles :
                </p>
                <p className={css.paragraph}>
                  📧 Email : <a href="mailto:contact@neokasa.fr" className={css.legalLink}>contact@neokasa.fr</a><br />
                  👁 CNIL : <a href="http://www.cnil.fr" target="_blank" rel="noopener noreferrer" className={css.legalLink}>www.cnil.fr</a>
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>14. Politique relative aux mineurs</h2>
                <p className={css.paragraph}>
                  La Marketplace n'est pas destinee aux mineurs. Nous ne collectons pas volontairement de donnees personnelles de mineurs.
                </p>
              </section>
            </div>

            <div className={css.contactSection}>
              <h2 className={css.contactTitle}>Besoin d'aide concernant la Politique de Confidentialité ?</h2>
              <p className={css.contactText}>
                Pour toute question concernant vos données personnelles, vos droits ou notre politique de confidentialité, notre équipe d'assistance est à votre disposition.
              </p>
              <div className={css.contactButtons}>
                <a href="/contact" className={css.contactButton}>
                  Contacter le support
                </a>
                <a href="mailto:contact@neokasa.fr" className={css.contactButtonSecondary}>
                  Assistance par e-mail
                </a>
              </div>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default PrivacyPolicyPage;
